export const errorCode = {
  B0001: 'System Error',
  A1001: '分类名称已经存在',
  A1002: '主题名称已经存在',
  A1003: '已经跟运营方案绑定，不允许删除',
  A1004: '主品牌名字已经存在',
  A1005: '子品牌名字已经存在',
  A2001: '运营方案名称已经存在',
  A2002: '运营方案不允许删',
  V1001: '已存在运行中的方案',
  V1011: '子推荐区域已经存在',
  B0002: '数据导入失败,请按下载文档校正再导入',
  B0003: '数据导入失败,请按下载文档校正再导入',
  B0004: '数据导入失败,请按下载文档校正再导入',
  V5001: '调用翻译接口失败'
}